import React, { useState } from "react";
import { toastError } from "../../../utils/toastUtils";
import Label from "../../../components/FormComponents/Label";
import Input from "../../../components/FormComponents/Input";
import Textarea from "../../../components/FormComponents/Textarea";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Button from "../../../components/FormComponents/Button";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const validationTypeOptions = [
  { id: "default", name: "Default" },
  { id: "custom", name: "Custom" }
];

const defaultRegexOptions = [
  { id: "^[A-Z]{5}[0-9]{4}[A-Z]$", name: "Pan Card" },
  { id: "^\\d{12}$", name: "Aadhar Card" }
];

const returnValidation = (regex) => {
  const defaultRegex = defaultRegexOptions.find((option) => option.id === regex);
  return defaultRegex ? defaultRegex.name : regex;
};

const OCRQuestionsEditor = ({ questions, setQuestions }) => {
  const [newQuestion, setNewQuestion] = useState({ key: "", question: "", description: "" });
  const [editingIndex, setEditingIndex] = useState(null);
  const [editQuestion, setEditQuestion] = useState({ key: "", question: "" });

  const handleQuestionChange = (name, value) => {
    setNewQuestion({ ...newQuestion, [name]: value });
  };

  const handleEditQuestionChange = (name, value) => {
    setEditQuestion({ ...editQuestion, [name]: value });
  };

  const addQuestion = () => {
    if (!newQuestion.key || !newQuestion.question) {
      toastError("Key and Question are required");
      return;
    }
    const updatedQuestions = [...questions, newQuestion];
    setQuestions(updatedQuestions);
    setNewQuestion({ key: "", question: "", description: "" });
  };

  const deleteQuestion = (index) => {
    const updatedQuestions = questions.filter((_, i) => i !== index);
    setQuestions(updatedQuestions);
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditQuestion(questions[index]);
  };

  const handleSave = (index) => {
    const updatedQuestions = questions.map((q, i) => (i === index ? editQuestion : q));
    setQuestions(updatedQuestions);
    setEditingIndex(null);
  };

  return (
    <>
      <Label>Add New Question</Label>
      <div className="d_flex gap_2 mt_2">
        <div className="d_flex align_end gap_3" style={{ minWidth: "300px" }}>
          <Input
            label="Key"
            name="key"
            value={newQuestion.key}
            onChange={(e) => handleQuestionChange(e.target.name, e.target.value)}
          />
          <Input
            label="Question"
            name="question"
            value={newQuestion.question}
            onChange={(e) => handleQuestionChange(e.target.name, e.target.value)}
          />
          <Input
            label="Description"
            name="description"
            value={newQuestion.description}
            onChange={(e) => handleQuestionChange(e.target.name, e.target.value)}
          />

          <SingleSelectBox
            label={"Validation Type"}
            selectedData={newQuestion.validation_type}
            options={validationTypeOptions}
            onChange={(obj) => handleQuestionChange("validation_type", obj.id)}
          />

          {newQuestion.validation_type === "default" && (
            <SingleSelectBox
              selectedData={newQuestion.validation}
              options={defaultRegexOptions}
              onChange={(obj) => handleQuestionChange("validation", obj.id)}
              placeholder="Select Regex"
            />
          )}

          {newQuestion.validation_type === "custom" && (
            <Input
              name="validation"
              value={newQuestion.validation}
              onChange={(e) => handleQuestionChange(e.target.name, e.target.value)}
              placeholder="Custom Validation"
            />
          )}

          <Button onClick={addQuestion}>Add Question</Button>
        </div>
      </div>

      {questions.length > 0 && (
        <table className="table mt_3">
          <thead>
            <tr>
              <th>Key</th>
              <th>Question</th>
              <th>Validation</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {questions.map((q, index) => (
              <tr key={index}>
                <td>
                  {editingIndex === index ? (
                    <Input
                      name="key"
                      value={editQuestion.key}
                      onChange={(e) => handleEditQuestionChange(e.target.name, e.target.value)}
                    />
                  ) : (
                    q.key
                  )}
                </td>
                <td>
                  {editingIndex === index ? (
                    <Input
                      name="question"
                      value={editQuestion.question}
                      onChange={(e) => handleEditQuestionChange(e.target.name, e.target.value)}
                    />
                  ) : (
                    q.question
                  )}
                </td>
                <td>{editingIndex === index ? editQuestion.validation : returnValidation(q.validation)}</td>
                <td>
                  {editingIndex === index ? (
                    <Textarea
                      name="description"
                      value={editQuestion.description}
                      onChange={(e) => handleEditQuestionChange(e.target.name, e.target.value)}
                    />
                  ) : (
                    q.description
                  )}
                </td>
                <td>
                  {editingIndex === index ? (
                    <MaterialIcon name="save" className="builder_action_btn" onClick={() => handleSave(index)} />
                  ) : (
                    <div className="d_flex gap_3">
                      <MaterialIcon name="edit" className="builder_action_btn" onClick={() => handleEdit(index)} />
                      <MaterialIcon
                        name="delete"
                        className="builder_action_btn"
                        onClick={() => deleteQuestion(index)}
                      />
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default OCRQuestionsEditor;
